import { InferFormValues, JsonFormSchemaV2 } from '@/catalog-apps/components/component-library/FormComponent/types'
import { ComposedSheet } from './ComposedSheet'
import { ReactNode, useRef } from 'react'
import { TooltipWrapper } from './TooltipWrapper'
import {
  FormContentV2,
  FormContentHandle,
} from '@/catalog-apps/components/component-library/FormComponent/FormContentV2'
import { SheetClose } from '@/components/shadcn/sheet'

export function SheetWithFormSchema({
  schema,
  onSubmit,
  trigger,
  triggerTooltip,
  onSuccess,
  closeOnSuccess = false,
  isSubmitting,
  wide = true,
}: {
  schema: JsonFormSchemaV2
  onSubmit: (data: InferFormValues<typeof schema>, onSuccess?: () => void) => void
  trigger: ReactNode
  triggerTooltip?: string
  onSuccess?: () => void
  closeOnSuccess?: boolean
  isSubmitting?: boolean
  wide?: boolean
}) {
  const { title, description, ...rest } = schema
  const formRef = useRef<FormContentHandle>(null)
  const sheetCloseRef = useRef<HTMLButtonElement>(null)

  const handleSuccess = () => {
    console.log('SheetWithForm - handleSuccess')
    if (onSuccess) {
      onSuccess()
    }

    if (closeOnSuccess && sheetCloseRef.current) {
      sheetCloseRef.current.click()
    } else if (formRef.current) {
      formRef.current.reset()
    }
  }

  const sheet = (
    <ComposedSheet wide={wide} title={title} description={description} trigger={triggerTooltip ? undefined : trigger}>
      <SheetClose ref={sheetCloseRef} className="hidden" />
      <FormContentV2
        ref={formRef}
        schema={rest}
        submitHandler={(data) => {
          onSubmit(data, handleSuccess)
        }}
        isSubmitting={isSubmitting}
      />
    </ComposedSheet>
  )

  if (triggerTooltip)
    return (
      <TooltipWrapper tooltip={triggerTooltip} wrapTrigger triggerComponent={sheet}>
        {trigger}
      </TooltipWrapper>
    )

  return sheet
}
